import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import Input from '../input';
import { wire } from './hoc/prop-wire';
/**
 * A React Tabs view component
 * @constructor
 * @param {string} [id] - Tab dom element #id
 * @param {string} [className] - Classname for the container
 * @param {object} menu Tab menu config
 * @param {object} menu.key menu item config
 * @param {renderable} menu.key.title menu item title
 * @param {string} menu.key.disabled is menu item disabled (cannot select)?
 * @param {string} menu.isEditTitle is menu item title edit
 * @param {string} [defaultCurrent] - Default selected tab key
 * @param {string} [current] - Current selected tab key
 * @param {object} [currentLink] - Link to update selected tab key. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} currentLink.value - value to update
 * @param {function} currentLink.requestChange - function to request value change
 * @param {object} [defaultContents] - Key-node pair of what to display in each tab by default
 * @param {renderable} [children] - Current tab content
 * @param {function} [onChange] - Callback function when tab is selected. <br> Required when current prop is supplied
 * @param {string} onChange.value - selected tab key
 * @param {object} onChange.eventInfo - event related info
 * @param {string} onChange.eventInfo.before - previously selected tab
 * 
 * @param {bool} [enableAddTabs] - Enable add tab function
 * @param {function} [onTabAdd] - Callback function when tab menu is created
 * @param {bool} [enableDeleteTabs] - Enable delete tab function
 * @param {function} [onTabDelete] - Callback function when tab menu is deleted
 * @param {bool} [enableEditTabsTitle] - Enable tab menu title edit function
 * @param {function} [onEditMenu] - Callback function when tab menu title is edited
 *
 * @todo  Maybe don't need defaultContents??
 *
 * @example
// controlled

import {Tabs} from 'react-ui'

React.createClass({
    getInitialState() {
        return {
            currentTab:'movies'
        }
    },
    handleTabChange(newTab) {
        this.setState({currentTab: newTab})
    },
    renderMovies() {
        return 'movie list'
    },
    renderActors() {
        return 'actor list'
    },
    render() {
        let {currentTab} = this.state;
        return <Tabs id='imdb'
            menu={[
				{
					key: 'movies',
                	title: 'MOVIES',
					disabled: false,
					isEditTitle: false
				},
				{
					key: 'actors',
                	title: 'ACTORS',
					disabled: false,
					isEditTitle: false
            	},
				{
					key: 'tv',
                	title: 'TV',
					disabled: true,
					isEditTitle: false
				}
			]}
            current={currentTab}
            onChange={this.handleTabChange}>
            {
                currentTab==='movies' ? this.renderMovies() : this.renderActors()
            }
        </Tabs>
    }
})
 */

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTabChange", function (e) {
      _this.props.onChange(e.currentTarget.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabAdd", function () {
      _this.props.onTabAdd();
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabDelete", function (key) {
      _this.props.onTabDelete(key);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenEdit", function (key) {
      var menu = _this.state.menu;

      var newMenu = _.cloneDeep(menu);

      _.map(newMenu, function (el) {
        if (el.key === key) el.isEditTitle = !el.isEditTitle;else el.isEditTitle = false;
      });

      _this.props.onEditMenu(key, true);

      _this.props.onChange(key);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (key, value) {
      _this.props.onEditMenu(key, false, value);
    });

    _this.state = {}; // this.handleClickOutside = this.handleClickOutside.bind(this)

    return _this;
  } // componentDidMount() {
  // 	document.addEventListener('mousedown', this.handleClickOutside);
  //   }
  // componentWillUnmount() {
  // 	document.removeEventListener('mousedown', this.handleClickOutside);
  // }
  // handleClickOutside(e) {
  // 	if(this.tabs && !this.tabs.contains(e.target))
  // 		this.props.closeEditMenu()
  // }


  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          menu = _this$props.menu,
          current = _this$props.current,
          defaultContents = _this$props.defaultContents,
          id = _this$props.id,
          className = _this$props.className,
          children = _this$props.children,
          enableAddTabs = _this$props.enableAddTabs,
          enableDeleteTabs = _this$props.enableDeleteTabs,
          enableEditTabsTitle = _this$props.enableEditTabsTitle,
          menuTitleValidate = _this$props.menuTitleValidate;
      var defaultContent = defaultContents[current];
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: cx('c-tabs', className)
      }, /*#__PURE__*/React.createElement("ol", {
        ref: function ref(_ref) {
          return _this2.tabs = _ref;
        },
        className: "menu"
      }, _.map(menu, function (item, index) {
        var isCurrent = item.key === current;
        var disabled = item.disabled || false;
        var title = item.title || item.key;
        {
          /* if (_.isString(item)) {
          title = item;
          } else {
          title = item.title || item.key;
          disabled = item.disabled;
          } */
        }
        var tabClassName = {
          current: isCurrent,
          disabled: disabled
        };
        return /*#__PURE__*/React.createElement("li", {
          id: item.key,
          key: item.key,
          className: cx(tabClassName),
          onClick: isCurrent || disabled ? null : _this2.handleTabChange
        }, item.isEditTitle ? /*#__PURE__*/React.createElement(Input, {
          className: 'tab-input',
          value: item.title,
          required: true,
          validate: menuTitleValidate,
          onChange: _this2.handleInputChange.bind(_this2, item.key)
        }) : title, enableEditTabsTitle && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt tab-edit-icon",
          onClick: function onClick(e) {
            e.stopPropagation();

            _this2.handleOpenEdit(item.key);
          }
        }), enableDeleteTabs && menu.length > 1 && /*#__PURE__*/React.createElement("i", {
          className: "fa fa-times-circle tab-delete-icon",
          onClick: function onClick(e) {
            e.stopPropagation();

            _this2.handleTabDelete(item.key);
          }
        }));
      }), enableAddTabs && /*#__PURE__*/React.createElement("li", {
        onClick: this.handleTabAdd
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus"
      }))), /*#__PURE__*/React.createElement("div", {
        id: current,
        className: "tabContent"
      }, children || defaultContent));
    }
  }]);

  return Tabs;
}(React.Component);

_defineProperty(Tabs, "defaultProps", {
  menu: {},
  defaultContents: {},
  enableAddTabs: false,
  enableDeleteTabs: false,
  enableEditTabsTitle: false
});

_defineProperty(Tabs, "propTypes", {
  id: PropTypes.string,
  className: PropTypes.string,
  menu: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    title: PropTypes.node,
    disabled: PropTypes.bool
  })])),
  current: PropTypes.string,
  defaultContents: PropTypes.objectOf(PropTypes.node),
  children: PropTypes.node,
  onChange: PropTypes.func,
  enableAddTabs: PropTypes.bool,
  onTabAdd: PropTypes.func,
  enableDeleteTabs: PropTypes.bool,
  onTabDelete: PropTypes.func,
  enableEditTabsTitle: PropTypes.bool,
  onEditMenu: PropTypes.func
});

export default wire(Tabs, 'current');